var exports = {
  "k": "xdbfd91f1--f4eed9--container",
};

module.exports = exports;
